import { STORE_AGREEMENT_CARDS } from "actions"

export const initialState = []

export const agreementCards = (state = initialState, action) => {
  switch (action.type) {
    case STORE_AGREEMENT_CARDS:
      return [...action.payload]
    default:
      return state
  }
}

export default agreementCards
